import styled from 'styled-components';

export const Wrapper = styled.div<{ $isActive: boolean }>`
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, $isActive }) => ($isActive ? theme.colors.black9 : theme.colors.black4)};
  background: ${({ theme }) => theme.colors.white};
`;

export const TitleWrapper = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const StyledImage = styled.img`
  width: fit-content;
  max-width: 100%;
`;
